export var OS;
(function (OS) {
    OS[OS["MAC"] = 0] = "MAC";
    OS[OS["IOS"] = 1] = "IOS";
    OS[OS["WINDOWS"] = 2] = "WINDOWS";
    OS[OS["ANDROID"] = 3] = "ANDROID";
    OS[OS["LINUX"] = 4] = "LINUX";
})(OS || (OS = {}));
export const isMobile = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
};
// https://stackoverflow.com/a/38241481
export const getOperatingSystem = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    // default to Mac
    let os = OS.MAC;
    if (macosPlatforms.indexOf(platform) !== -1) {
        os = OS.MAC;
    }
    else if (iosPlatforms.indexOf(platform) !== -1) {
        os = OS.IOS;
    }
    else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = OS.WINDOWS;
    }
    else if (/Android/.test(userAgent)) {
        os = OS.ANDROID;
    }
    else if (!os && /Linux/.test(platform)) {
        os = OS.LINUX;
    }
    return os;
};
export const getTriggerKey = (event) => {
    if ([OS.WINDOWS, OS.ANDROID, OS.LINUX].includes(getOperatingSystem())) {
        return event.ctrlKey;
    }
    else {
        return event.metaKey;
    }
};
export const osControlKey = (suffix) => {
    if ([OS.WINDOWS, OS.ANDROID, OS.LINUX].includes(getOperatingSystem())) {
        if (!!suffix) {
            return `Ctrl-${suffix}`;
        }
        return 'Ctrl';
    }
    else {
        if (!!suffix) {
            return `⌘${suffix}`;
        }
        return '⌘';
    }
};
//# sourceMappingURL=data:application/json;base64,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